import { ReactNode, useEffect } from 'react';
import { LinearProgress, useColorScheme } from '@mui/material';
import BounceSoupBallList from './BounceSoupBallList';

export interface PageLoadingScreenProps {
    isLoading: boolean;
    message?: string;
    children?: ReactNode;
}

const PageLoadingScreen = ({ isLoading, message, children }: PageLoadingScreenProps) => {
    let isExist = isLoading;
    const { mode } = useColorScheme();

    useEffect(() => {
        if (isLoading) {
            isExist = true;
        }
    }, [isLoading]);

    return (
        <>
            {isExist && (
                <div
                    onTransitionEnd={() => {
                        if (!isLoading) {
                            isExist = false;
                        }
                    }}
                    className={'flex fixed items-center justify-center inset-0 transition-opacity p-5'}
                    style={{
                        backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.6)',
                        zIndex: isExist ? 9998 : 0,
                        opacity: isLoading ? 1 : 0,
                    }}
                >
                    <div className={'flex items-center flex-col gap-4'}>
                        <BounceSoupBallList />
                        {/* <LinearProgress sx={{mb:2, width: '160px',}} /> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default PageLoadingScreen;
